import { observable, configure, action, computed } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';
import { route } from 'preact-router';
import PubSub, { topics } from '../lib/pubsub';

configure({ enforceActions: 'always' });

class StreamDeviceStore extends LocalModel {
    constructor() {
        super('streamDevice', {
            namePlural: 'streamDevices',
            namePluralReal: 'streamDevices',
            sort: 'timestamp',
            limit: 500,
            api: {
                search: {
                    url: '/api/streamdevices/',
                    params: {
                        limit: 15,
                        sort: 'timestamp',
                    },
                },
                load: {
                    url: '/api/streamdevices/',
                    params: {},
                },
                save: {
                    url: '/api/streamdevices/',
                    params: {},
                },
                delete: {
                    url: '/api/streamdevices/',
                    params: {},
                },
            },
        });
    }

    @observable newStreamDevice = {};

    @observable streamDevice = {};

    @observable streamDevices = [];
}

const store = new StreamDeviceStore();
export default store;
